import React, { Fragment, useEffect } from "react";
import { Layout as AntLayout, BackTop,Tooltip } from "antd";
import { animation, stickyNav } from "./utils";
import Header from "./Header";
import Footer from "./Footer";

const { Content: AntContent } = AntLayout;

const Layout = ({ children, header, className, footer, noHeader }) => {
  useEffect(() => {
    animation();
    document.querySelector("body").className = className
      ? className
      : "oxence_body";
  }, [className]);

  useEffect(() => {
    window.addEventListener("scroll", stickyNav);
  }, []);

  return (
    <Fragment>

      <AntLayout className="page-wrapper">
        {!noHeader && (
          <Header  header={header} />
        )}

        <AntContent className="main-content ">
          <div className="content-wrapper">{children}</div>
        </AntContent>
        <Footer footer={footer} />
        <Tooltip title="Scroll to Top" placement="left"><BackTop /></Tooltip>
        
      </AntLayout>
    </Fragment>
  );
};

export default Layout;
